import React from 'react';
import { Wrapper } from './MContentSwap.styles';
import { type MContentSwapFlag, type MContentSwapProps, MContentSwapType } from './MContentSwap.types';
import { MButton } from '../MButton/index';
import { type MButtonProps, MButtonType } from '../MButton/MButton.types';
import { MListTextIcon } from '../MListTextIcon/index';
import { type MListTextIconProps } from '../MListTextIcon/MListTextIcon.types';

const COMPONENT_NAME = 'm-web-ui-kit-MContentSwap';
const TEST_ID = 'web-ui-kit-MContentSwap';

const isTruthyFlag = (value?: MContentSwapFlag): boolean => value === true || value === 'true';

const hasButtonContent = (item?: MButtonProps): boolean =>
  !!item && !!(item.buttonText || item.children || item.ctaLink || item.href);

function MContentSwap({
  type = MContentSwapType.Button,
  alignment,
  mButton,
  mButton2,
  button2,
  mListTextIcon,
  mListTextIcon2,
  listItem2,
  ...rest
}: MContentSwapProps) {
  const isListTextIcon = type === MContentSwapType.ListTextIcon;

  const listItems: (MListTextIconProps | undefined)[] = [
    mListTextIcon,
    isTruthyFlag(listItem2) ? mListTextIcon2 : undefined,
  ];
  const buttonItems: (MButtonProps | undefined)[] = [
    hasButtonContent(mButton) ? mButton : undefined,
    isTruthyFlag(button2) && hasButtonContent(mButton2) ? mButton2 : undefined,
  ];

  const hasActiveItem = isListTextIcon ? Boolean(listItems[0]) : Boolean(buttonItems[0]);
  if (!hasActiveItem) return null;

  return (
    <Wrapper data-component-name={COMPONENT_NAME} data-testid={TEST_ID} $alignment={alignment} {...rest}>
      {isListTextIcon
        ? listItems.map((item, index) => item && <MListTextIcon key={index} {...item} />)
        : buttonItems.map((item, index) => {
            if (!item) return null;

            const { type: buttonType, ...rest } = item as MButtonProps & { type?: string };

            return <MButton key={index} {...rest} buttonType={buttonType as MButtonType} />;
          })}
    </Wrapper>
  );
}

export { MContentSwap, MContentSwapType, TEST_ID as M_CONTENT_SWAP_TEST_ID };
